import CopyToClipboard from "components/molecules/CopyToClipboard/CopyToClipboard";

interface HeaderAddressV2Props {
  address_name?: string;
  street?: string;
  street_line_two?: string;
  city?: string;
  state?: string;
  country?: string;
  zipcode?: string;
  useRevampedDesign?: boolean;
  /** When true (airport/seaport pickup or delivery), show port name and country only — hide street/city/zip details. */
  portLocationOnly?: boolean;
}

export default function HeaderAddressV2({
  address_name,
  street,
  street_line_two,
  city,
  state,
  country,
  zipcode,
  useRevampedDesign,
  portLocationOnly,
}: HeaderAddressV2Props) {
  const detailCopyFields = [address_name, street, street_line_two, city, state, country, zipcode].filter(Boolean);
  const portCopyFields = [(address_name ?? "").trim(), country].filter(Boolean);
  const copyText = portLocationOnly ? portCopyFields.join(", ") : detailCopyFields.join(", ");

  if (useRevampedDesign)
    return (
      <div style={{ position: "relative" }}>
        <CopyToClipboard copyOnly text={copyText}>
          <div className="topnav-v2__location-name">{address_name}</div>
          {portLocationOnly && country ? (
            <div className="topnav-v2__location-address">
              <div>{country}</div>
            </div>
          ) : null}
          {!portLocationOnly && (
            <div className="topnav-v2__location-address">
              <div>{street}</div>
              <div>{street_line_two}</div>
              <div>
                {city}
                {city && zipcode && `, `}
                {zipcode}
              </div>
              <div>
                {state}
                {state && country && `, `}
                {country}
              </div>
            </div>
          )}
        </CopyToClipboard>
      </div>
    );

  if (portLocationOnly) {
    return (
      <CopyToClipboard copyOnly text={copyText}>
        <div>
          <div className="font-weight-bold text-xs font-roboto">{address_name}</div>
          {country ? <div className="font-b2">{country}</div> : null}
        </div>
      </CopyToClipboard>
    );
  }

  return (
    <CopyToClipboard copyOnly text={detailCopyFields.join(", ")}>
      <div>
        <div className="font-weight-bold text-xs font-roboto">{address_name}</div>
        <div className="font-b2">{street}</div>
        <div className="font-b2">{street_line_two}</div>
        <div className="font-b2">
          {city}
          {state && `, ${state}`}
          {zipcode && `, ${zipcode}`}
        </div>
        <div className="font-b2">{country}</div>
        {/* <AddressLocodeAndCustomFields
          location_reference_number={location_reference_number}
          custom_address_reference={custom_address_reference}
          un_locode={un_locode}
          un_locode_className="font-b4"
        /> */}
      </div>
    </CopyToClipboard>
  );
}

HeaderAddressV2.defaultProps = {
  address_name: undefined,
  street: undefined,
  street_line_two: undefined,
  city: undefined,
  state: undefined,
  country: undefined,
  zipcode: undefined,
  useRevampedDesign: false,
  portLocationOnly: false,
};
